import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import styles from './AppHeader.module.scss';
import layoutStyles from '../AppLayout.module.scss';

import { ThemeContext } from 'app-themes';

import CreateBookingModal from 'AppClient/components/CreateBookingModal';

import { withRouter, RouteComponentProps } from 'react-router';

import AppMenu from 'AppClient/routes/AppLayout/AppHeader/AppMenu';
import { PATHS } from '../AppContent/AppContent';
import { LogoutButton } from 'components';
import { inject, observer } from 'mobx-react';
import { RootStore, UserStore } from 'AppClient/stores';

const { Header } = Layout;
interface Props extends RouteComponentProps<{}> {
	userStore?: UserStore;
}
const AppHeader: React.FC<Props> = props => {
	const { userInfo } = props.userStore!;
	const { firstName = '', lastName = '' } = userInfo! || {};
	return (
		<ThemeContext.Consumer>
			{(theme: string) => (
				<Header
					className={classNames(styles.appHeader, {
						[styles[`appHeader-${theme}`]]: theme !== '',
					})}
				>
					<div className={layoutStyles.appWrapper}>
						<div className={styles.appLogoWrapper}>
							<div
								className={styles.appLogo}
								onClick={() => props.history.push('/')}
								aria-label="button"
							/>
						</div>
						<div className={styles.appNavAndAuth}>
							<AppMenu />
							<div className={styles.appAuth}>
								<div className={styles.appAuthBox}>
									<CreateBookingModal />
								</div>
								<div className={styles.appAuthBox}>
									<div className={styles.appAuthItem}>
										<Link
											to={`/userProfile`}
											className={classNames(styles.appAuthLink, {
												[styles.active]:
													props.location.pathname ===
													`/${PATHS.userProfile}`,
											})}
										>
											{firstName} {lastName}
										</Link>
									</div>
									<LogoutButton to="/logout" text="Log out" />
								</div>
							</div>
						</div>
					</div>
				</Header>
			)}
		</ThemeContext.Consumer>
	);
};
const StoreWrapper = inject(({ userStore }: RootStore) => ({ userStore }))(observer(AppHeader));
export default withRouter(StoreWrapper);
